{
  "level": "field7",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:field7",
    "objects": "AREAS.E3:field7.e3",
    "mesh": "TREES.E3:field7.e3"
  },
  "spawn_point": {
    "position": [
      0.0,
      0.0,
      0.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      0.0,
      100.0,
      0.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      0.0,
      0.0,
      0.0
    ],
    "bbox_max": [
      0.0,
      0.0,
      0.0
    ],
    "vertex_count": 0,
    "vertices": []
  },
  "sectors": [
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -2799.999755859375,
      "bbox_min": [
        -2799.999755859375,
        -4372.7998046875,
        1092.623779296875
      ],
      "bbox_max": [
        -2799.999755859375,
        -4370.7685546875,
        1122.623779296875
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CSlidingDoor piece: field7",
      "entity_class": "CSlidingDoor",
      "piece_name": "field7",
      "offset": 437,
      "centroid": [
        600.0,
        964.4151068793403,
        111.11111111111111
      ],
      "bbox_min": [
        600.0,
        919.8679809570312,
        60.0
      ],
      "bbox_max": [
        600.0,
        1000.0,
        160.0
      ],
      "dimensions_source": {
        "span_x": 0.0,
        "span_y": 80.13201904296875,
        "height_z": 100.0,
        "door_width": 80.13201904296875,
        "door_depth": 0.0,
        "leaf_depth": 0.05,
        "clearance_margin": 0.02,
        "slide_axis": "z"
      },
      "vertices": [
        [
          600.0,
          980.0,
          80.0
        ],
        [
          600.0,
          980.0,
          120.0
        ],
        [
          600.0,
          980.0,
          160.0
        ],
        [
          600.0,
          1000.0,
          160.0
        ],
        [
          600.0,
          1000.0,
          120.0
        ],
        [
          600.0,
          970.0,
          60.0
        ],
        [
          600.0,
          930.0,
          60.0
        ],
        [
          600.0,
          919.8679809570312,
          160.0
        ],
        [
          600.0,
          919.8679809570312,
          80.0
        ]
      ]
    }
  ],
  "tutorial_messages": []
}